import { calcCategoryGoalRatingAvg } from './calcCategoryGoalRatingAvg'
import { store } from '@/store'

/**
 * Get the average of goal ratings for a category
 */
export const getCategorySubcategoryGoalRatingAvg = (frameworkId, compassId, compassCategoryId) => {
  const subCatResponse = store.getters['compass-sub-categories/list']
  const compassSubCategories = subCatResponse
    .filter(subCat => subCat.compassId === compassId && subCat.isEnabled && !subCat.isRequired)
  const categorySubCategories = compassSubCategories.filter(subCat => {
    if (subCat.compassCategoryId) {
      return subCat.compassCategoryId === compassCategoryId
    }
    return false
  })
  return calcCategoryGoalRatingAvg(categorySubCategories.map(subCat => subCat.goalRating))
}
